
export class ReportsNavigationModule {
    //static get ReportsV2(): string { return "app.reports2"; }
    static get ReportList(): string { return `${ReportsNavigationModule.ParentRoot}.list`; }
    static get ViewReport(): string { return `${ReportsNavigationModule.ReportList}.view`; }
    static get ReportSchedules(): string { return `${ReportsNavigationModule.ParentRoot}.schedules`; }
    static get Expenses(): string { return `${ReportsNavigationModule.ParentRoot}.expenses`; }
    static get History(): string { return `${ReportsNavigationModule.ParentRoot}.history`; }

    static get Default(): string { return ReportsNavigationModule.ParentRoot; }

    static get ParentRoot(): string { return "app.reports2"; }
}
